export const JOB_LIMITS = {
    MAX_OUTPUT_PIXELS: 500 * 1_000_000
};

export function applyJobLimitsPolicy(policy = {}) {
    if (!policy || typeof policy !== 'object') return;
    if (policy.max_output_pixels != null) {
        const val = Math.max(0, Number(policy.max_output_pixels));
        if (!Number.isNaN(val) && val > 0) {
            JOB_LIMITS.MAX_OUTPUT_PIXELS = val;
        }
    }
}
